module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/060-benin-17e3559d7d43bdbef7be66b6f21e9ef7.svg";